import { useQuery } from "@tanstack/react-query";
import { fetchCountries } from "../api/countries.api";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";

const useCountries = () => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["countries"],
    queryFn: () => fetchCountries(bearerToken),
  });

  const fetchCountriesData = async () => {
    await refetch();
  };

  return {
    countries: data,
    error,
    isLoading,
    fetchCountriesData,
  };
};

export default useCountries;
